(function(){
  /* ---------------------------------------------------------- accordions */
  document.addEventListener("click", (e) => {
    const head = e.target.closest("[data-accordion-head]");
    if (!head) return;
    const item = head.closest(".accordion__item");
    const body = item.querySelector(".accordion__body");
    const icon = head.querySelector(".accordion__icon");
    const isOpen = item.classList.toggle("is-open");
    if (body) body.hidden = !isOpen;
    if (icon) icon.textContent = isOpen ? "−" : "+";
    head.setAttribute("aria-expanded", isOpen ? "true" : "false");
  });

  /* ---------------------------------------------------- contact-form success */
  if (window.location.search.indexOf("contact_posted=true") !== -1) {
    const success = document.querySelector("[data-form-success]");
    if (success) {
      success.hidden = false;
      const form = document.querySelector("[data-form-fields]");
      if (form) form.hidden = true;
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  /* --------------------------------------------------- multi-file uploader */
  document.querySelectorAll("[data-uploader]").forEach((u) => {
    const input = u.querySelector("[data-upload-input]");
    const cta = u.querySelector("[data-upload-cta] span");
    const list = u.querySelector("[data-upload-list]");
    const urlField = u.querySelector("[data-upload-url]");
    const cloud = u.getAttribute("data-cloud");
    const preset = u.getAttribute("data-preset");
    if (!input || !cloud || !preset) return;
    const urls = [];
    let pending = 0;
    const form = u.closest("form");
    const submit = form ? form.querySelector('[type="submit"]') : null;
    const sync = () => {
      urlField.value = urls.join("\n");
      if (submit) submit.disabled = pending > 0;
      if (cta) cta.textContent = pending > 0 ? "Uploading…" : (urls.length ? "Add more files" : "Click to upload photos or files");
      u.classList.toggle("is-uploaded", urls.length > 0);
    };
    const row = (name, msg, err) => {
      const li = document.createElement("li");
      li.style.color = err ? "#FF5A47" : "#5fd0a3";
      li.textContent = (err ? "✕ " : "✓ ") + name + (msg ? " — " + msg : "");
      list.appendChild(li);
      return li;
    };
    input.addEventListener("change", () => {
      Array.from(input.files || []).forEach(async (file) => {
        if (file.size > 10 * 1024 * 1024) { row(file.name, "over 10 MB, paste a share link below instead", true); return; }
        pending++; sync();
        const li = row(file.name, "uploading…");
        li.style.color = "#B8B3C0";
        const fd = new FormData();
        fd.append("file", file);
        fd.append("upload_preset", preset);
        try {
          const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud}/auto/upload`, { method: "POST", body: fd });
          const data = await res.json();
          if (!data.secure_url) throw new Error("no url");
          urls.push(file.name + ": " + data.secure_url);
          li.style.color = "#5fd0a3"; li.textContent = "✓ " + file.name + " uploaded";
        } catch (err) {
          li.style.color = "#FF5A47"; li.textContent = "✕ " + file.name + " failed, try again or paste a link below";
        } finally { pending--; sync(); }
      });
      input.value = "";
    });
  });

})();
